import type {CompRef, PS} from '@wix/document-services-types'
import _ from 'lodash'
import componentDetectorAPI from '../../componentDetectorAPI/componentDetectorAPI'
import component from '../../component/component'
import dataModel from '../../dataModel/dataModel'
import dsUtils from '../../utils/utils'
import type {DsFixer} from '../dsDataFixers'

const LOGIN_BAR_TYPE = 'wysiwyg.viewer.components.LoginSocialBar'

const isValidMenuRef = (ps: PS, menuData) =>
    !!dataModel.getDataItemById(ps, dsUtils.stripHashIfExists(menuData.menuRef))

const removeBrokenMembersLoginBar = (ps: PS, compPointer: CompRef) => {
    const compData = dataModel.getDataItem(ps, compPointer)
    const compWithInvalidMenuRef = [compData.menuItemsRef, compData.iconItemsRef].some(
        menu => menu && !isValidMenuRef(ps, menu)
    )
    if (compWithInvalidMenuRef) {
        component.remove(ps, compPointer)
    }
}

const fixer: DsFixer = {
    exec(ps: PS) {
        const loginBarComps = componentDetectorAPI.getComponentByType(ps, LOGIN_BAR_TYPE)
        _.forEach(loginBarComps, comp => removeBrokenMembersLoginBar(ps, comp))
    },
    name: 'brokenLoginBarFixer',
    version: 1
}
export default fixer
